export enum CalculationAmountTaxedType {
    FULL = 'full',
    PROFIT = 'profit',
}
